import React from "react";
import TitleStyle from "../../../../assets/stylesheets/experience/sections/ExperienceTitleSection.module.css";

export default function ExperienceTitleSection({ experience, farmName }) {
  return (
    <div className={TitleStyle["exp-title-section"]}>
      <div className={TitleStyle["exp-title-row"]}>
        <h2 className={TitleStyle["exp-experience-title"]}>{experience.title}</h2>
      </div>
      <div className={TitleStyle["exp-meta-row"]}>
        {experience.category && (
          <span className={TitleStyle["exp-category-badge"]}>{experience.category}</span>
        )}
        {experience.duration && (
          <span className={TitleStyle["exp-meta-chip"]}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            {experience.duration}
          </span>
        )}
        {experience.groupSize && (
          <span className={TitleStyle["exp-meta-chip"]}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
            </svg>
            Up to {experience.groupSize} guests
          </span>
        )}
      </div>
      {experience.description && (
        <p className={TitleStyle["exp-description-text"]}>{experience.description}</p>
      )}
    </div>
  );
}
